<template>
   <v-card style="overflow-y: auto;">
      <block v-if="loading"></block>
      <v-card-title>
        Editar abono            
      </v-card-title>
      <v-card-subtitle>
        <div>
          <span><b>ID:</b> {{ customer?.ID_Customer }} <b>Cliente:</b> {{ customer?.LegalName }}</span>
        </div>
        <div style="font-size: 1.2rem; margin: 0.5rem 0;">
          <span><b>ID Abono:</b> {{ receivableId }}</span>&nbsp; 
          <span><b>Monto Total:</b> <span>{{ currency }}</span> {{ receivableTotalAmount }}</span>
        </div>
      </v-card-subtitle>
       <v-card-text>
        <div>
          <h3 style="margin: 0 1rem;">Pagos actualmente vinculados:</h3>
        </div>
        <DxDataGrid 
          :dataSource="tableData"
          :showBorders="true"
          ref="currentPaymentsDataGrid"
          :scrolling="{ useNative: true }"
          :paging="{ enabled: false }"  
          style="max-height: 600px;"
        >
            <!--DxColumn  dataField="ID_AccountsReceivablePayment" caption="ID de Pago" width="200" /-->
            <DxColumn dataField="ID_Invoice" caption="ID de Factura" />
            <DxColumn  dataField="CodigoGeneracion" caption="Código de Generación" />
            <DxColumn  dataField="PaymentShow" caption="Pago Realizado" />
            <DxColumn  dataField="PaymentType" caption="Tipo de pago" />
            <DxColumn cell-template="deleteBtn" :allow-editing="false" caption=""/>
            <template #deleteBtn="{ data }">
              <div>
                <v-btn style="background-color: #e7473c; color: white;" @click="removePayment(data.data)">
                  Eliminar
                  <v-icon color="white">mdi-delete</v-icon>
                </v-btn>
              </div>
            </template>
            <DxPager :visible="true" :show-page-size-selector="false" :show-info="false" :show-navigation-buttons="true" />
            <!--DxPaging :page-size="10" /-->
        </DxDataGrid>
        <div v-if="dirty">
          <div class="actions">
            <div style="margin-right: 1rem; font-size: 1.15rem; color: #e7473c">
              <span><b>Faltante:</b> <span>{{ currency }}</span> {{ parseFloat( receivableTotalAmount - totalEditPayment ).toFixed( 2 ) }}</span>
            </div>
            <div class="buttons">
              <v-btn 
                color="success" 
                style="background-color: #e7473c; color: white;" @click="updatePayments()"
                :disabled="totalEditPayment !== receivableTotalAmount">
                Guardar Cambios
                <v-icon color="white">mdi-floppy</v-icon>
              </v-btn>
              <v-btn 
                color="warning" style="background-color: #f29d35; color: white;" @click="restore()">
                Restaurar
                <v-icon color="white">mdi-broom</v-icon>
              </v-btn>
              <v-btn style="background-color: #1976d2; color: white;" @click="$emit('close')">
                Cancelar
              </v-btn>
            </div>
          </div>
          <div  v-if="currentPaymentsTotal < receivableTotalAmount">
            <div>
              <h3 style="margin: 0 1rem;">Para asociar el pago de una factura al abono, modificar la celda (Abono a realizar):</h3>
            </div>
            <DxDataGrid
              ref="availablePaymentsDataGrid"
              :dataSource="invoicePendingToPay"
              :showBorders="true"
              :scrolling="{ useNative: true }"
              :allow-column-resizing="true"
              column-resizing-mode="widget"
              :column-min-width="50"
              :column-auto-width="true"
              @cellClick="handleCellClick"
            >
              <DxColumn data-field="PaymentToBeMade" caption="Abono a realizar" data-type="number" :allow-editing="true">
                <DxFormat typed="fixedPoint" :precision="2"/>
                <DxPatternRule :pattern="paymentPattern"
                message="El abono no puede tener números negativos" />
                <DxAsyncRule :validation-callback="checkPaymentValue"
                message="La cantidad del abono no puede exceder al pendiente de la factura" />
                <DxAsyncRule :validation-callback="checkPaymentTotal"
                message="La cantidad del abono no puede exceder al total del abono." />
              </DxColumn>
              <DxColumn cell-template="pending-pay" :allow-editing="false" caption="Pendiente"/>
              <DxEditing :allow-updating="true" :select-text-on-edit-start="true" start-edit-action="click"
              mode="cell" />
              <DxColumn dataField="ID_Invoice" :allow-editing="false" caption="ID de Factura" width="175" />
              <DxColumn dataField="CodigoGeneracion" :allow-editing="false" caption="Código Generación" width="320" />
              <DxColumn dataField="InvoiceDate" :allow-editing="false" caption="Fecha de emisión" width="150" />
              <DxColumn dataField="PaymentEndDate" :allow-editing="false" caption="Fecha de vencimiiento" width="175" />
              <DxColumn cell-template="total-pay" :allow-editing="false" caption="Adeudado" />
              <template #total-pay="{ data }">
                  {{ data.data.InvoiceTotalPagar.toFixed(2) }}
              </template>
              <template #pending-pay="{ data }">
                  {{ data.data.PendingToPay.toFixed(2) }}
              </template>
              <DxColumn cell-template="canceled" :allow-editing="false" caption="Abonado" />
              <template #canceled="{ data }">
                  {{ data.data.Canceled.toFixed(2) }}
              </template>
              <DxColumn cell-template="expired-inv" :allow-editing="false" caption="Expirada"/>
              <template #expired-inv="{ data }">
                  <div v-if="data.data.IsInvoiceExpired == 1" class="text-danger">
                  <v-icon
                  
                  color="error"
                  >
                      mdi-alert-circle
                  </v-icon>
                  </div>
                  <div v-else class="text-success">
                  <v-icon
                  color="success"
                  >
                      mdi-check-circle
                  </v-icon>
                  </div>
              </template>
            </DxDataGrid>
          </div>
        </div>
        <div v-else class="clean-actions">
          <v-btn style="background-color: #1976d2; color: white;" @click="$emit('close')">
            Cancelar
          </v-btn>
        </div>
       </v-card-text>
       <alerts v-if="alert.show" v-on:close_alert="closeAlert" v-on:accept_alert="closeAlert" :properties="alert"></alerts>
   </v-card>
</template>

<script>
  import {DxColumn, DxDataGrid, DxFormat, DxEditing, DxPatternRule, DxAsyncRule, DxPager} from 'devextreme-vue/data-grid';
  import Alerts from '@/components/Alerts.vue';
  import Block from "@/components/Block";
  
  export default {
    name: 'HistoricReceivableEditor',
    components: {
      DxPager,
      DxColumn,
      DxDataGrid,
      DxFormat,
      DxEditing,
      DxPatternRule,
      DxAsyncRule,
      Alerts,
      Block,
    },
    props: {
      'data': {
         type: Object,
         required: true
      },
      'dataType': {
        type: String,
        required: true
      },
      'refresh': {
        type: Function,
        required: true,
      }
    },
    data () {
      return {
        invoicePendingToPay: [],
        currentPayments: [],
        paymentPattern: /^(0*[0-9][0-9]*(\.[0-9]+)?|0+\.[0-9]*[0-9][0-9]*)$/i,
        originalCellValue: 0.0,
        loading: false,
        alert: {
            type: "success",
            show: false,
            header: "",
            body: "",
        },
        dirty: false
      }
    },
    computed: {
      customer() {
        return this.data.customer
      },
      receivable() {
        return this.data.receivable
      },
      receivableId() {
        const firstItemData = this.receivable.items[0]
        // return firstItemData.ID_Receipt != null ? firstItemData.ID_Receipt : firstItemData.ID_AccountsReceivable
        return firstItemData.ID_AccountsReceivable
      },
      receivableTotalAmount() {
        const firstItemData = this.receivable.items[0]
        return parseFloat( firstItemData.TotalPayment.toFixed( 2 ) );
      },
      payments() {
        return this.receivable.items
      },
      currency() {
        return JSON.parse(localStorage.getItem('branch')).Currency;
      },
      tableData() {
        return this.currentPayments.map((item)=>{
            item.PaymentShow = this.currency + " " + item.Payment.toFixed(2)
            return item
        });
      },
      paymentsToBeMade() {
        return this.invoicePendingToPay.filter((ip) => ip.PaymentToBeMade > 0)
      },
      paymentsToBeMadeTotal() {
        return this.paymentsToBeMade.reduce((total, invoice) => total + invoice.PaymentToBeMade, 0)
      },
      currentPaymentsTotal() {
        return this.currentPayments.reduce((total, invoice) => total + invoice.Payment, 0)
      },
      totalEditPayment() {
        return parseFloat( parseFloat( this.currentPaymentsTotal + this.paymentsToBeMadeTotal ).toFixed( 2 ) ) 
      },
    },
    methods: {
      async getInvoicePendingToPay() {
          this.$API.customers.getInvoicePendingToPay({ "ID_Customer": this.customer.ID_Customer, "envType": this.dataType })
            .then(response => {
                this.invoicePendingToPay = response.map(item => ({...item, PaymentToBeMade: 0}));
            });
      },
      async updatePayments() {
        this.loading = true
        
        try {
          await this.$refs.availablePaymentsDataGrid.instance.saveEditData()

          const totalPayment = parseFloat( parseFloat( this.currentPaymentsTotal + this.paymentsToBeMadeTotal ).toFixed( 2 ) )

          if( totalPayment !== this.receivableTotalAmount ){
            this.showAlert( "warning", "Error", 'La suma total de los pagos no puede diferir del monto del abono.');
            this.loading = false;
            return;
          }

          const invoiceCredits = [...this.currentPayments,  ...this.paymentsToBeMade]
          
          const reqData = {
            invoiceCredits,
            ID_AccountsReceivable: this.receivableId,
          }

          const response = await this.$API.customers.updateAccountReceivablePayments(reqData)
          this.showAlert("success", "Éxito", response.message, "closeModal")
          this.refresh()
          // this.$emit('close')

        } catch(err) {
          this.showAlert("danger", "Error", "Ocurrio un problema al realizar el update, por favor intentarlo nuevamente")
          this.loading = false;
        }
      },
      removePayment(data) {
        this.currentPayments = this.currentPayments.filter((item) => {
          return item.ID_AccountsReceivablePayment !== data.ID_AccountsReceivablePayment
        })
        this.dirty = true
      },
      handleCellClick(e){
          const val = e.data.PaymentToBeMade
          this.originalCellValue = val
      },
      async checkPaymentValue(params){
        const { data: { PendingToPay, PaymentToBeMade } } = params
        
        if(PaymentToBeMade > PendingToPay) {
          return false
        }
        else{
          this.dirty = true
          return true
        }
      },
      async checkPaymentTotal(params){
        const { data: { PaymentToBeMade, ID_Invoice } } = params

        let total = parseFloat( parseFloat( this.currentPaymentsTotal + this.paymentsToBeMadeTotal + PaymentToBeMade ).toFixed( 2 ) )

        const currentData = this.paymentsToBeMade.find((p) => p?.ID_Invoice === ID_Invoice)

        if (currentData) {
          total -= currentData.PaymentToBeMade
        }
        
        if(total > this.receivableTotalAmount) {
          return false
        }
        else{
          this.dirty = true
          return true
        }
      },
      showAlert(type, header, body, options = null) {
        type = type == null ? "danger" : type;

        this.alert = {
          type,
          header,
          body,
          show: true,
          options: options != null ? options : null
        }
      },
      closeAlert(){
        this.alert.show = false;

        if (this.alert.options == "closeModal") {
            this.$emit("close");
        }
      },
      async restore() {
        await this.getInvoicePendingToPay()
        this.currentPayments = [...this.payments]
        this.dirty = false
      }
    },
    watch: {
      'payments': function (val) {
        this.currentPayments = [...val]
      }
    },
    async mounted(){
      await this.restore()
    },
  }
</script>

<style scoped>
.actions {
  margin: 0 1rem 1.5rem 1rem;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.clean-actions {
  margin: 0 1rem 1.5rem 1rem;
  display: flex;
  flex-direction: row;
  justify-content: end;
  align-items: center;
}

.buttons > button {
  margin: 0 0.5rem;
}
</style>